(function () {
  'use strict';
  angular.module('cabinFlightAdmin').controller('addCabinFlightFeedbackPopupCtrl',addCabinFlightFeedbackPopupCtrl)

  function addCabinFlightFeedbackPopupCtrl(modalParams, MessageService, PopupManager, cabinFlightAdminService) {

    var vm=this;
    vm.cabinFlightVersion = modalParams.cabinFlightVersion;
    vm.cabinFlightReportId = modalParams.cabinFlightReportId;
    vm.crewSchdBlockId = modalParams.crewSchdBlockId;
    vm.errors = {
      feedback:''
    };
    vm.feedBack="";

    loadFeedbackPanelData();

    vm.setCabinFlightRemarkId=function(cabinFlightRemarkId,row){
      vm.cabinFlightRemarksId=cabinFlightRemarkId;
      vm.selectedRow=row;
    }



    vm.submitCabinFlightReportFeedback=function () {
      if(!isFomValid()){
        return;
      }
      clearErrors();
      updateFeedBack()


    }

    vm.sendCabinFlightReportFeedback=function () {
      sendFeedback();
    }

    function updateFeedBack() {
      let param = {
        "cabinFlightRemarksId": vm.cabinFlightRemarksId,
        "feedback": vm.feedBack
      };

      let  reportId=vm.cabinFlightReportId;

      cabinFlightAdminService.updateCabinFlightReportFeedback(param,function (response) {

        //reload remark list
        getCabinFlightReportRemarkList(reportId);

      },function (error) {
        PopupManager.closeModal('ADD_CABIN_FLIGHT_FEEDBACK');
      })

    }

    function isFomValid() {
      let valid=true
      if(vm.feedBack!=null&&vm.feedBack.length==0){
        vm.errors.feedback='Feedback is required';
        valid=false;
      }
      if(!vm.cabinFlightRemarksId){
        vm.errors.feedback='Please select a specific record from above table'
        valid=false;
      }
      return valid;
    }
    function clearErrors() {
      vm.errors.feedback='';
    }



    function loadFeedbackPanelData() {
      let param = {
        "cabinFlightVersion": vm.cabinFlightVersion,
        "cabinFlightReportId": vm.cabinFlightReportId,
        "crewSchdBlockId": vm.crewSchdBlockId
      };

      let  reportId=vm.cabinFlightReportId;
      getCabinFlightReportRemarkList(reportId);
      getEditFlightPopUpDetails(param);
    }

    function getCabinFlightReportRemarkList(reportId){
      cabinFlightAdminService.getCabinFlightReportRemarkList(reportId,function (response) {
        vm.cabinFlightReportRemarkList=response.cabinFlightReportRemarkDTOList;

      },function (error) {
        PopupManager.closeModal('ADD_CABIN_FLIGHT_FEEDBACK');
      })
    }

    function getEditFlightPopUpDetails(param){
      cabinFlightAdminService.getEditFlightPopUpDetails(param, function(response) {
        vm.flightReportsTabData = response.flightReportsTabData;

      }, function(error) {
        MessageService.error(error.msg[0]);
        PopupManager.closeModal('ADD_CABIN_FLIGHT_FEEDBACK');
      })
    }
    function sendFeedback(){
      let param = {
        "cabinFlightReportId": vm.cabinFlightReportId,
        "crewSchdBlockId": vm.crewSchdBlockId,
        "cabinFlightRemarks": vm.cabinFlightReportRemarkList
      };
      cabinFlightAdminService.sendCabinFlightReportFeedback(param,function (response) {
        if(response.success){
          MessageService.success('Cabin Flight Report Feedback Sent Successfully');
          PopupManager.closeModal('ADD_CABIN_FLIGHT_FEEDBACK');
        }
      },function (error) {
        MessageService.error(error.msg[0]);
        PopupManager.closeModal('ADD_CABIN_FLIGHT_FEEDBACK');
      })
    }

    vm.closeFeedbackPopup = function() {
      PopupManager.closeModal('ADD_CABIN_FLIGHT_FEEDBACK');
    }




  }

}());
